import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BodisplayModule } from '../../bodisplay';
import { RendezVousV3FormateurComponent } from './rendezvousformateur.component';

@NgModule({
  declarations: [
    RendezVousV3FormateurComponent
  ],
  exports: [
    RendezVousV3FormateurComponent
  ],
  imports: [
    CommonModule,
    BodisplayModule
  ]
})

export class RendezVousV3FormateurModule { }
